export default __webpack_public_path__ + "static/media/640_dummy2016-baeckerei01-de.b46d6626.png";